import { gql } from "@apollo/client";

export const PERFORMANCE_GRAPH_FRAGMENT = gql`
  fragment PerformanceGraphFragment on PortfolioPerformanceGraph {
    nodes {
      value
      timestamp
    }
    grossReturnAbsolute
    grossReturnPercentage
  }
`;

export const SIP_FRAGMENT = gql`
  fragment SipFragment on Sip {
    id
    recurringDepositInCents
    recurringDepositSchedule
    paused
    status
  }
`;
